import TasksAdvanceFilterFormProps from '../../../components/filters/models/TasksAdvanceFiltersFormProps';

export const defaultTaskFilterValues: TasksAdvanceFilterFormProps = {
  jobTitles: [],
  jobCodes: [],
  company: [],
  locations: [],
  teams: [],
  recruiters: [],
  createBWDates: null,
  updatedBWDates: null,
};
